import { Field as HeadlessField } from '@headlessui/react';

export function Field({ children }: Readonly<{ children: React.ReactNode }>) {
	return <HeadlessField className="relative">{children}</HeadlessField>;
}
